module.exports = __webpack_public_path__ + "static/media/whichThinnerLowerRisk.43577ca9.mp3";